import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../../context/SocketContext';
import { useParams } from 'react-router-dom';
import { Col, Form } from 'react-bootstrap';

const TabInterfaces = () => {
    const { id } = useParams();
    const idR = atob(id);
    const { socket } = useContext(SocketContext);
    const [host, setHost] = useState('');
    const [athers, setAthers] = useState([]);
    const [state, setState] = useState('');

    const handleChange = (e) => {
        setState(e.target.value);
    };

    useEffect(() => {
        getInter();
    }, [idR]);
    const getInter = async () => {
        await socket.emit('ethersmk', idR, (status) => {
            if (status) {
                if (status.ok) {
                    setAthers(status.data);
                    setHost(status.host);
                } else {
                    setAthers([]);
                }
            }
        });
    };
    return (
        <div className="p-4">
            <div>
                <Col sm={6}>
                    <Form.Group className="mb-3" controlId="validationCustom022">
                        <Form.Label> Seleccionar Interface {idR}</Form.Label>
                        <Form.Select value={state} name="seguridad" required onChange={handleChange}>
                            <option value="">Seleccione interfaz</option>
                            {athers.map((et) => (
                                <option value={et.name}>{et.name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </div>
            <div style={{ maxWidth: '100%', maxHeight: '100px' }}>
                {state && (
                    <iframe src={`http://${host}:8080/graphs/iface/${state}/`} width="100%" height="100%"></iframe>
                )}
            </div>
        </div>
    );
};

export default TabInterfaces;
